export const sk = {
  hanab: "Hanab",
  welcome: "Vitaj",
  newGame: "Nová hra",
  tagline: "Zahraj si Hanab online s priateľmi!",
  subTagline: "Kooperatívna kartová hra pre viac hráčov dostupná na mobile, tablete a počítači",
  createRoom: "Vytvoriť miestnosť",
  joinRoom: "Vstúpiť do miestnosti",
  rejoinGame: "Znova sa pripojiť",
  whatsHanab: "Čo je Hanab?",
  invitationByPlayers_0: "{{playerNames}} ťa pozýva zahrať si Hanab 🎉",
  invitationByPlayers_1: "{{playersNames}} ťa pozývajú zahrať si Hanab 🎉",
  invitationNoPlayers: "Boli ste pozvaní zahrať si Hanab 🎉",
  gameFull: "Všetci sú tu!",
  gameNotFull_0: "{{count}} z {{playersCount}} hráčov sa pripojil",
  gameNotFull_1: "{{count}} z {{playersCount}} hráčov sa pripojili",
  gameNotFull_2: "{{count}} z {{playersCount}} hráčov sa pripojilo",
  startGame: "Začať hru",
  addAi: "+ pridať bota",
  lobby: "Lobby",
  choosePlayerName: "Zvoľ si meno",
  join: "Pripojiť sa",
  autoplay: "Automatické prehrávanie",
  shareGame: "Zdieľať túto hru",
  copy: "Kopírovať",
  waitForOthers: "Čakať na ostatných alebo ",
  gameStarted: "Hra začala!",
  gameStarts: "Hra sa začína!",
  discardPile: "Odhadzovací balíček ({{ discardLength }})",
  preventLossContent: "Vybuchli ste · Chcete pokračovať?",
  rewind: "🕑 Prehrať históriu",
  backToGame: "Naspäť do hry",
  theirTurn: "{{currentPlayerName}} je práve na rade!",
  go: "Ďalej",
  estimatedMaxScore: "Odhadované skóre pre tento balíček: {{reachableScore}}.",
  keepPracticing: "Pokračujte v precvičovaní",
  congrats: "Neuveriteľné!",
  hideStats: "Skryť štatistiky",
  showStats: "Zobraziť štatistiky",
  gameOver: "Koniec hry! • Získali ste {{playedCardsLength}} bodov 🎉",
  score: "Hanab • Skóre: {{score}} / {{maxPossibleScore}}",
  turnsLeftDisclaimer_0: "· Posledný ťah",
  turnsLeftDisclaimer_1: "· {{count}} ťahy do konca",
  turnsLeftDisclaimer_2: "· {{count}} ťahov do konca",
  cardLeft: "{{pileLength}} kariet v balíčku",
  tokens: "žetóny",
  deck: "balíček",
  loading: "Načítava sa...",
  menu: "Menu",
  tutorial: "Tutoriál",
  rules: "Pravidlá",
  yourTurn: "Si na rade!",
  youWillStart: "Začínaš!",
  hide: "Skryť",
  reveal: "Zobraziť",
  cardSelected: "karta {{position}} označená",
  eightTokens: "8 nápovied",
  cannotDiscard: "Nemôžeš zahodiť",
  noTokens: "Nápovedy sa minuli",
  selectVignette: "Na použitie nápovedy označ farbu alebo číslo",
  hint: "Nápoveda",
  negativeHintColor: "Nemáš žiadnu {{ color }} kartu", //zelenú
  negativeHintNumber: "Nemáš žiadnu kartu s číslom {{ number }}",
  positiveHintColor_0: "Karta {{ positions }} je {{ color }}", //zelená
  positiveHintNumber_0: "Karta {{ positions }} má hodnotu {{ number }}",
  positiveHintNumberSequence_0: "Karta {{ positions }} má hodnotu {{ number }} alebo väčšiu",
  positiveHintColor_1: "Karty {{ positions }} sú {{ color }}", //zelené
  positiveHintNumber_1: "Karty {{ positions }} majú hodnotu {{ number }}",
  positiveHintNumberSequence_1: "Karty {{ positions }} majú hodnoty {{ number }} alebo väčšie",
  you: "Ty",
  hinted: "Poradené",
  played: "Zahrané",
  discarded: "Zahodené",
  rollback: "Vrátiť ťah",
  rollbackDisclaimer: "Naozaj chceš vrátiť poslednú akciu?",
  cannotRollback: "Akcia sa nedá vrátiť",
  abort: "Zrušiť",
  introTutorial: "Tutoriál",
  introContent: "Rýchla ukážka!",
  playedCardsTutorial: "Zahrané karty",
  playedCardsTutorialContent: "Tu vidíš zahrané karty. Cieľom je poukladať na kôpku každej farby karty od 1 po 5.",
  discardTutorial: "Zahodené karty",
  discardTutorialContent: "Tu sú karty, ktoré ste zahodili. Nezahadzuj karty, ktoré potrebujete na výhru.",
  yourGameTutorial: "Tvoje karty",
  yourGameTutorialContent:
    "Toto sú tvoje karty.\nNemôžeš ich vidieť, ale ostatní hráči môžu a budú ti radiť, čo na nich je.",
  teammatesTutorial: "Spoluhráči",
  teammatesTutorialContent:
    "Toto sú tvoji spoluhráči.\nPodobne ako ty, ani oni nevidia svoje karty.\nPoraď im, ktoré karty majú zahrať alebo zahodiť.",
  hintTokensTutorial: "Žetóny nápovedy",
  hintTokensTutorialContent:
    "Niektoré akcie nie sú zadarmo.\n\n- Poradiť spoluhráčovi môžeš za žetón nápovedy.\n- Zahodením karty získate 1 žetón nápovedy.\n- Úspešným zahraním karty s hodnotou 5 tiež získate žetón nápovedy.",
  strikeTokensTutorial: "Žetóny výbuchu",
  strikeTokensTutorialContent:
    "Zahraním nesprávnej karty o ňu prídete a dostanete žetón výbuchu. Po troch výbuchoch končí hra.",
  yourTurnTutorial: "Si na rade",
  yourTurnTutorialContent:
    "Máš 3 možnosti:\n\n- Označ kartu, ktorú chceš zahrať...\n- ... alebo zahodiť\n- Klikni na spoluhráča, ktorému chceš poradiť.",
  skip: "✕ Preskočené",
  offline: "Nemáš internetové spojenie so serverom!",
  apologies: "Prepáč, niečo sa pokazilo 😕",
  errorWillInvestigate: "Pokúsime sa vyšetriť problém čo najskôr. Neváhaj nám <1>napísať</1>, čo sa stalo.",
  earlyDevelopment: "Hra je stále vo vývoji, potešíme sa akejkoľvek spätnej väzbe.",
  publicRepo: "Máme <1>verejný Github repozitár</1>, ak by ste chceli niečo zmeniť alebo nahlásiť chybu.",
  backMenu: "Naspäť do menu",
  landingImageAlt: "Hanab logo online hry",
  classicVariant: "Klasický",
  orangeVariant: "Oranžový",
  multicolorVariant: "🎨 Viacfarebný",
  rainbowVariant: "🌈 Dúhový",
  criticalRainbowVariant: "🌈 Ťažký dúhový",
  sequenceVariant: "Neisté poradie",
  classicVariantDescription: "Klasická hra Hanab s piatimi farbami",
  multicolorVariantDescription:
    "Hra s pridanou šiestou farbou, ale šiesta farba má iba po jednej karte z každej hodnoty",
  rainbowVariantDescription: "Hra s pridanou šiestou farbou, ktorá pri nápovedách zodpovedá každej farbe",
  criticalRainbowVariantDescription: 'Dúhový variant, ale dúhová "farba" má iba po jednej karte z každej hodnoty',
  orangeVariantDescription: "Hra s pridanou šiestou farbou",
  sequenceVariantDescription: "Číselné nápovedy radia aj vyššie hodnoty",
  showDirectHints: "Zobrazovať existujúce nápovedy",
  hideDirectHints: "Skryť to, čo už bolo poradené",
  botSpeed: "Rýchlosť bota",
  normalGameExplanation: "Môžeš hrať online nazdieľaním linku tvojím priateľom.",
  passandplayExplanation:
    'V móde "Podaj ďalej" môžeš hrať s viacerými hráčmi offline tak, že si budete podávať jedno zariadenie.',
  private: "Súkromná hra",
  hints: "Nápovedy",
  allowRollback: "Dovoliť vrátenie ťahu",
  preventLoss: "Zabrániť prehre",
  passandplay: "Podaj ďalej",
  passandplaySubtext: "Fyzicky si budete podávať zariadenie, podľa toho, kto je práve na rade.",
  privateSubtext: 'Vaša hra nebude viditeľná v zozname "Vstúpiť do miestnosti".',
  advancedOptions: "Pokročilé možnosti",
  players: "Počet hráčov",
  mode: "Variant hry",
  seed: "Inicializačná hodnota pre generátor náhodných čísiel",
  objective: "Cieľ hry",
  rulesIntro:
    "Hanab je kartová hra od Antoine Bauza. Je kooperatívna, teda hra, v ktorej hráči nehrajú proti sebe, ale snažia sa plniť spoločný cieľ. V tomto prípade predstavujete roztržitých tvorcov obrovského ohňostroja, ktorým sa náhodou podarilo pomiešať všetok strelný prach, rakety a rozbušky. Šou sa o chvíľu začína a panika sa šíri. Musíte spolupracovať, aby ste zabránili katastrofe.",
  rulesGoal:
    "Musíte dať dokopy 5 ohňostrojov (biely, červený, modrý, žltý a zelený) tak, že ich čísla budú stúpať od jednotky po päťku (v každej farbe).",
  rulesSetupTitle: "Príprava hry",
  rulesSetup:
    "Stránka pripravila všetko za vás, a to sa oplatí 😉! Na začiatku hry máte 8 modrých žetónov nápovedy a 3 červené žetóny výbuchu.\n\nBalíček obsahuje 50 kariet, 10 každej farby s číslami 1, 1, 1, 2, 2, 3, 3, 4, 4, 5.\n· V hre dvoch (2) alebo troch (3) hráčov dostane každý hráč 5 kariet.\n· V hre štyroch (4) alebo piatich (5) hráčov dostane každý 4 karty.\n\nAko (ne)uvidíte, nikto si nevidí svoje vlastné karty, ale vidí karty všetkých spoluhráčov.",
  rulesGameTitle: "Priebeh hry",
  rulesGame:
    "Hráč vo svojom ťahu musí spraviť práve jednu z nasledujúcich troch akcií. Ťah sa nedá preskočiť.\n\n1. Poradiť inému hráčovi.\n2. Zahodiť kartu.\n3. Zahrať kartu.\n\nPoznámka: Ostatní spoluhráči nesmú počas hráčovho ťahu akokoľvek komentovať jeho rozhodovanie!",
  rulesHintTitle: "1. Poradiť inému hráčovi",
  rulesHint:
    "Pokiaľ si vyberieš radiť inému hráčovi, bude vás to stáť jeden modrý žetón nápovedy. Poznámka: Túto akciu nemôžeš vykonať, ak už nemáte žiadny modrý žetón. V tom prípade musíš zahrať inú akciu.\n\nAkciu vykonáš tak, že klikneš na karty iného hráča. Označiť môžeš buď karty rovnakej farby, alebo s rovnakým číslom. Dôležité: Napovedajúci hráč dáva kompletnú informáciu. Ak má hráč dve zelené karty, napovedajúci hráč označí obe z nich.",
  rulesDiscardTitle: "2. Zahodiť kartu",
  rulesDiscard:
    "Zahodením karty získate jeden modrý žetón nápovedy. Kartu z ruky zahodíš kliknutím na ňu. Potom si potiahneš novú kartu z balíčka (nová karta ti automaticky príde na ruku).\nPoznámka: Ak máte 8 žetónov nápovedy, nemôžeš zahodiť kartu a musíš si zvoliť inú akciu.\nO zahodených kartách už môžete diskutovať.",
  rulesPlayTitle: "3. Zahrať kartu",
  rulesPlay:
    'Ak chceš zahrať kartu, vyber kartu z ruky a klikni na "Zahrať".\nNásledne sa stane jedna z dvoch vecí:\n· Ak karta začína ohňostroj novej farby alebo pokračuje už začatý, karta bude pridaná k ohňostroju.\n· Ak karta nepokračuje v žiadnom ohňostroji ani nezačína nový, tak bude zahodená a pribudne vám jeden žetón výbuchu.\nPotom ti do ruky príde nová karta z balíčka.\n\nKeď niekto dokončí ohňostroj zahraním karty s číslom 5, ako odmenu získate jeden modrý žetón nápovedy ako bonus (pokiaľ je to možné, teda už nemáte 8 žetónov nápovedy).',
  rulesEndTitle: "Koniec hry",
  rulesEnd:
    "Hanab môže skončiť jedným z troch spôsobov:\n· V momente, ako získate tretí žetón výbuchu, celé pódium zhorí v plameňoch!\n· Keď sa vám podarí skompletizovať všetky ohňostroje predtým, ako sa minie balíček. Získavate tak 25 (30, ak hráte 🎨 viacfarebný variant) bodov a ide o obdivuhodné víťazstvo!\n· Keď potiahnete poslednú kartu z balíčka, hra je takmer na konci. Každý hráč zahrá ešte svoj posledný ťah, vrátane hráča, ktorý potiahol poslednú kartu. Počas tohto posledného kola si hráči už nemôžu ťahať nové karty (veď ani nemajú z čoho).\n\nKeď skončí posledné kolo, hra končí a hráči si môžu spočítať svoje finálne skóre.",
  rulesExtensionTitle: "Rozšírenia",
  rulesExtensionMulticolor:
    "🎨 Viacfarebný variant pridáva do balíčka 5 dúhových kariet. Tieto tvoria novú farbu. Môžeš o nich radiť ostatným rovnako ako o iných kartách (napríkad „Máš dve dúhové karty, tu a tu.“). Kedže táto farba má z každej hodnoty iba jednu kartu, dávajte si pozor, aby ste ich zbytočne nezahodili. Pravidlá sú rovnaké ako v normálnej hre, ale maximálne skóre je 30, keďže namiesto piatich ohňostrojov máte zostaviť šesť.",
  rulesExtensionRainbow:
    "🌈 V dúhovom variante taktiež pribúda šiesta, dúhová farba, tentokrát však s rovnakým počtom kariet ako ostatné farby. Ak chceš poradiť akúkoľvek farbu, musíš označiť aj všetky dúhové karty, keďže obsahujú danú farbu.",
  rulesUsTitle: "Kto sme?",
  rulesUs:
    "Sme skupina nadšencov pre stolové hry. Kvôli zákazu vychádzania v roku 2020 sme boli nútení nájsť alternatívu, ako sa hrať cez internet.\nKeďže nás baví programovať a hrať Hanab, bolo rozhodnuté! Vyrobili sme online verziu hry.\n\n👉 Prosím, kúp si aj <2>fyzickú verziu hry</2>, tak ako my! Podporíš tak originálnych tvorcov Hanab.",
  rulesContact: "✉️ <1>Napíšte nám</1>, ak máte akekoľvek otázky či návrhy.",
  rulesContributeRepo: "💻 Taktiež máme <1>verejný Github repozitár</1>, ak by ste sa chceli pridať.",
  rulesDiscordServer: "🗣 Pripojte sa k diskusii o zlepšeniach na našom Discord serveri.",
  rulesBuymeacoffee:
    "🙇‍♀️ Taktiež môžete podporiť našu iniciatívu a pomôcť nám pokryť prevádzkové náklady tým, že nám kúpite kávu.",
  noRoom: "Žiadna voľná miestnosť",
  faster: "Najrýchlejšie",
  fast: "Rýchlo",
  slow: "Pomaly",
  discard: "Zahodiť",
  play: "Zahrať",
  green: "zelená",
  red: "červená",
  yellow: "žltá",
  blue: "modrá",
  white: "biela",
  multicolor: "dúhová",
  green_0: "zelená",
  red_0: "červená",
  yellow_0: "žltá",
  blue_0: "modrá",
  white_0: "biela",
  multicolor_0: "dúhová",
  orange_0: "oranžová",
  green_1: "zelené",
  red_1: "červené",
  yellow_1: "žlté",
  blue_1: "modré",
  white_1: "bielé",
  multicolor_1: "dúhové",
  orange_1: "oranžové",
  green_2: "zelenú",
  red_2: "červenú",
  yellow_2: "žltú",
  blue_2: "modrú",
  white_2: "bielu",
  multicolor_2: "dúhovú",
  orange_2: "oranžovú",
  summary: "Zhrnutie",
  summarySubtitle: "Naša hra Hanab",
  gameCompleted: "Hra dokončená za {{ gameDuration }}",
  result: "Náš výsledok",
  evolution: "Priebeh hry",
  evolutionSubtext:
    "Pozrite si, ako ste hrali! Ku každej karte je napísané, či bola v danom čase hrateľná, zahoditeľná alebo riziková (to je taká karta, ktorej zahodenie by znížilo maximálny možný počet bodov).",
  playerActions: "Priemerný počet akcií na hráča/-ku",
  playHints: "Priemerný počet zahraných kariet na jednu nápovedu: <1>{{playsPerHint}}</1>",
  playerHints: "Kto najviac radil?",
  tryOutTitle: "Vyskúšaj to!",
  tryOutButton: "Vyskúšaj túto permutáciu",
  tryOutAlternative: "Tiež si môžeš zahrať iný variant alebo to skúsiť s našou AI na <1>hanab.cards</1>",
  back: "Naspäť",
  statsPlayable: "hrateľné",
  statsDiscardable: "zahoditeľné",
  statsDangerous: "rizikové",
  statsTurnCard: "V tom ťahu karta bola",
  statsTurnAction: "Hráč/-ka zahral/-a túto akciu v tom ťahu",
  showInsights: "Zobraziť detaily",
  showCards: "Zobraziť karty",
  started: "začaté",
  youGaveHintTurn: "Poradil/-a si <1></1> ohľadom jeho/jej <3></3>",
  youDiscardedTurn: "Zahodil/-a si <1></1>",
  youPlayedTurn: "Zahral/-a si <1></1>",
  somebodyHintedYouTurn: "<0></0> ti radí, že <2></2>",
  somebodyHintedSomebodyTurn: "<0></0> poradil/-a <2></2>, že <4></4>",
  somebodyDiscardedTurn: "<0></0> zahodil/-a <2></2>",
  somebodyPlayedTurn: "<0></0> zahral/-a <2></2>",
  whatYouDrewTurn: "a potiahol/-a <1></1>",
  whatTheyDrewTurn: "a potiahol/-a <1></1>",
  selectLanguage: "Vyber jazyk",
  creatingGame: "Vytváram hru...",
  partySetup: "Hráči: {{players}} · Variant: {{variant}} · Permutácia #{{shuffle}}",
  sendMessagePlaceholder: "Pošli správu spoluhráčom",
  sendMessage: "Odoslať",
  message: "<0></0>: <1></1>",
  colorBlindMode: "Mód pre farboslepých",
  colorBlindModeSubtext: "Zobrazí špeciálny symbol na vrchu každej karty, ktorý ti pomôže rozoznať farby.",
  pageNotFound: "Stránka sa nenašla",
  contributeLanguage: "Pomôž nám!",
  buymeacoffeePostGame: "Podpor nás tak, že nám <2>kúpiš kávu</2>.",
  next: "Ďalej",
  new: "Novinka",
  learnHanab: "Nauč sa hrať",
  learnHanabTime: "~5 min",
  learnWhileWaiting: "Nauč sa základy Hanab, kým čakáš na spoluhráčov",
  learnHanabEnglish: "Nauč sa Hanab - ",
  learn: {
    welcome: {
      title: "Nauč sa Hanab za 5 minút",
      1: "Ahoj! Toto je stručný tutoriál, hra je na tebe.",
      2: "Ale neboj sa! Poradíme ti, čo máš robiť!",
    },
    cooperation: {
      title: "Spolupráca",
      1: "Hanab ja kooperatívna hra.\n\nS ostatnými hráčmi sa snažíte dosiahnuť spoločný cieľ.",
    },
    colorBlind: {
      label: "Máš problém rozoznávať farby? Zapni si mód pre farboslepých.",
    },
    cards: {
      title: "Karty",
      1: {
        1: "Karty sú číslované od",
        2: "po",
        3: "a majú farby:",
        4: "alebo",
      },
      2: "Na začiatku hry každý hráč dostane 5 kariet.",
      3: "Nemôžeš vidieť vlastné karty, ale vidíš karty ostatných.",
    },
    goal: {
      title: "Cieľ hry",
      1: "Ako tím chcete zahrať karty všetkých farieb.",
      2: "Finálne kôpky každej farby sa budujú v zostupnom poradí.",
      3: "V tomto príklade musíš hrať",
      4: "predtým, ako zahráš",
      5: ".",
    },
    actions: {
      title: "Akcie",
      0: "Keď si na rade, môžeš si vybrať jednu z troch akcií",
      play: {
        title: "1. Zahranie karty",
        1: "Zahraj kartu z ruky na plochu.",
        2: "Ak sa karta nedala zahrať, karta sa zahodí a tím získava žetón výbuchu:",
        3: "Potiahni si novú kartu z balíčka.",
      },
      hint: {
        title: "2. Radenie",
        1: "Poraď niečo spoluhráčovi o kartách v jeho ruke.",
        2: "Poradenie spoluhráčovi stojí jeden žetón nápovedy:",
        3: "Môžeš poradiť jednu farbu alebo hodnotu.",
        4: "Napríklad v tejto ruke:",
        5: "Môžeš poradiť nasledovné veci:",
        6: "Tvoje karty A a B sú modré.",
        7: "Tvoje karty A a C sú dvojky.",
        8: "Tvoja karta E je žltá.",
        9: "Nemáš žiadnu zelenú kartu.",
      },
      discard: {
        title: "3. Zahadzovanie",
        1: "Zahoď kartu z ruky, s touto kartou sa ďalej už nebude hrať.",
        2: "Získaš jeden žetón nápovedy:",
        3: "Potiahni si novú kartu z balíčka.",
      },
    },
    tokens: {
      title: "Žetóny",
      1: "Žetóny nápovedy ti dovoľujú poradiť spoluhráčom.",
      2: "Na začiatku hry máte 8 žetónov nápovedy.",
      3: "Žetón výbuchu dostanete, keď niekto zahrá kartu, ktorá sa nedala zahrať.",
      4: "Po 3 vybuchnutiach ste prehrali hru.",
    },
    ready: {
      title: "Pripravení?",
      1: "Poďme si to vyskúšať na cvičnej hre!",
      2: "Hanab sa dá hrať rôznymi spôsobmi, môžeš používať rôzne stratégie. To, akú si zvolíš, je čisto na tebe.",
      3: "Dúfam, že ti tento tutoriál pomohol porozumieť základným pravidlám a stratégii, ktorú môžeš použiť pri hraní s priateľmi.",
      4: "Ďalej spomenuté konvencie nie sú súčasťou oficiálnych pravidiel, skôr triky, ktoré používajú niektorí hráči, aby boli efektívnejší. Ak ich chceš odhaliť bez pomoci, môžeš vypnúť tutoriál a ísť hrať.",
    },
  },
  howToContribute: "Ako pomôcť:",
  availableRooms: "Dostupné miestnosti",
};
